// Guest-owned copy of design console route names for navigation from guest/shared code.
// Admin imports from its own DesignConsoleRouter.types.tsx; this file avoids a cross-app dep.
export const DESIGN_CONSOLE_ROUTE_NAMES = {
  Templates: 'templates',
  Layout: 'layout',
  Color: 'color',
  Details: 'details',
  Art: 'art',
  Font: 'font',
  Css: 'css',
  EventPhoto: 'eventPhoto',
} as const;

export type DesignConsoleRouteName = (typeof DESIGN_CONSOLE_ROUTE_NAMES)[keyof typeof DESIGN_CONSOLE_ROUTE_NAMES];
